/*
 *  Author: DL
 *  Date: 2020-12-07 13:53:41
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-17 14:31:39
 *  LastEditors: DL
 *  Description: 工具类
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

/**
 * 防抖
 * @param {Function} fn
 * @param {Number} delay
 */
export function debounce(fn, delay) {
    let timer = null;
    return function() {
        if (timer) {
            clearInterval(timer);
        }
        timer = setTimeout(fn, delay);
    };
}

/**
 * 节流
 * @param {Function} fn
 * @param {Number} delay
 */
export function throttle(fn, delay) {
    let pre = Date.now();

    return function() {
        const _this = this;
        const args = arguments;
        var now = Date.now();
        console.log('now - pre', now - pre, delay);
        if (now - pre >= delay) {
            fn.apply(_this, args);
            pre = Date.now();
        }
    };
}

/**
 * 判断对象是否为空
 * @param {Object} obj
 */
export function isEmpty(obj) {
    if (!obj) return true;
    return JSON.stringify(obj) === '{}';
}

/**
 * 获取地址栏参数
 * @param {String} key
 */
export function getQueryString(key) {
    let search = window.location.search;

    if (!search) {
        const index = window.location.hash.indexOf('?');
        search = window.location.hash.slice(index);
    }

    search = search.slice(1);
    var arr = search.split('&');
    for (var i = 0; i < arr.length; i++) {
        var ar = arr[i].split('=');
        if (ar[0] === key) {
            return decodeURI(ar[1]);
        }
    }
    return '';
}
